<template>
    <div>
       <h3 class="text-themecolor">{{$t('homepage.welkombijfmmgmt')}} </h3>
    </div>
</template>
<script>
import { productInfo } from '@/mixins/productInfo'

export default {
    mixins: [productInfo]
}
</script>